import React from 'react';
import versions from '../../../versions.json';

interface VersionBadgeProps {
  portal: string;
  collapsed?: boolean;
}

export const VersionBadge: React.FC<VersionBadgeProps> = ({ portal, collapsed }) => {
  if (collapsed) return null;

  const platformVersion = versions.platform;
  const portalVersion = (versions.portals as Record<string, string>)[portal];

  return (
    <div style={{ padding: '8px 16px', fontSize: '10px', color: 'rgba(255,255,255,0.3)', textAlign: 'center' }}>
      {portalVersion
        ? `Platform ${platformVersion} | Portal ${portalVersion}`
        : `Platform ${platformVersion}`}
    </div>
  );
};
